import React, { useEffect, useState } from 'react';
import {
    Select,
    Button,
    Row,
    Col, Upload, Image, Form, Input, Checkbox, Table, Flex, Pagination, TableProps, Space, Breadcrumb,
    Input as AntInput, Switch, Popconfirm, Modal, Divider
} from 'antd';
import type {
    Products,
    Pn,
    Categories,
    BrandNames,
    ProductInfo,
    GST,
    Qn,
    Qnum,
    Fts,
    Bc,
    Sc,
    Count,
    Composition,
    Finish,
    Width,
    Hc,
    Pf,
    FPs,
    SaleType,
    Pus,
    Carings,
    Size,
    It,
    Sn,
    ProductVariants,
} from '../../../../types/CreateProductType';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { debounce } from 'lodash';
import { useParams } from 'react-router-dom';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { HomeOutlined, EditOutlined, DeleteOutlined, PlusOutlined, UploadOutlined, CopyOutlined } from '@ant-design/icons';
import { createStyles } from 'antd-style';
import VariantsModel from "./VariantsModel";
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';
import type { UploadProps, GetProp } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';
import GSTModal from '../../masters/gst/GSTModal'; // Adjust path if needed
import CategoryModal from '../../Category/CategoryModal';
import BrandNameModel from '../../masters/brand-names/BrandNameModel';
import PiModal from '../../masters/product-info/PiModal';
import PnModal from '../../masters/product-names/PnModal';
import QnModal from '../../masters/quality-names/QnModal';
import QnumModal from '../../masters/quality-numbers/QnumModal';
import FtModal from '../../masters/fabric-types/FtModel';
import CountModal from '../../masters/counts/CountModal';
import CompositionModal from '../../masters/compositions/CompositionModal';
import FinishModal from '../../masters/finishes/FinishModal';
import WidthModal from '../../masters/widths/WidthModal';
import HcModal from '../../masters/hsn-codes/HcModal';
import PuModal from '../../masters/product-uses/PuModal';
import CaringModel from '../../masters/caring/CaringModel';
import ItModal from '../../masters/inspection-tailorings/ItModal';
import FpModal from '../../masters/fabric-pattern/FpModal';
import VariantImageCell from '../../../../components/VariantImageCell'
import FpParentChildModal from './FpParentChildModal';

import { theme } from 'antd';
import CopyButton from '../../../../components/copyButton';

const { TextArea } = Input;
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];


const useStyle = createStyles(({ css }) => ({
    customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));


const CreateProduct: React.FC = () => {
    const [form] = Form.useForm();
    // const initialValues = null; 
    const { product_id } = useParams<{ product_id?: string }>();
    const [initialValues, setInitialValues] = useState<Products | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [variantinitialValues, setvariantInitialValues] = useState<ProductVariants | null>(null);
    const { styles } = useStyle();




    // const [previewOpen, setPreviewOpen] = useState(false);
    // const [previewImage, setPreviewImage] = useState('');
    // const [fileList, setFileList] = useState<UploadFile[]>([]);

    const [gsts, setGSTs] = useState<GST[]>([]);
    const [selectedGST, setSelectedGST] = useState<number | null>(null);
    const [isGSTModalVisible, setIsGSTModalVisible] = useState(false);

    const [categories, setCategories] = useState<Categories[]>([]);
    const [selectedCategories, setSelectedCategories] = useState<number | null>(null);
    const [isCategoryModalVisible, setIsCategoryModalVisible] = useState(false);

    const [brandnames, setBrandNames] = useState<BrandNames[]>([]);
    const [selectedBrandNames, setSelectedBrandNames] = useState<number | null>(null);
    const [isBrandNameModalVisible, setIsBrandNameModalVisible] = useState(false);

    const [productinfo, setProductInfo] = useState<ProductInfo[]>([]);
    const [selectedProductInfo, setSelectedProductInfo] = useState<number | null>(null);
    const [isProductInfoModalVisible, setIsProductInfoModalVisible] = useState(false);

    const [pns, setPns] = useState<Pn[]>([]);
    const [selectedPns, setSelectedPns] = useState<number | null>(null);
    const [isPnModalVisible, setIsPnModalVisible] = useState(false);

    const [selectedCompanyName, setSelectedCompanyName] = useState<number | null>(null);

    const [qns, setQns] = useState<Qn[]>([]);
    const [selectedQns, setSelectedQns] = useState<number | null>(null);
    const [isQnModalVisible, setIsQnModalVisible] = useState(false);


    const [qnums, setQnums] = useState<Qnum[]>([]);
    const [selectedQnums, setSelectedQnums] = useState<number | null>(null);
    const [isQnumModalVisible, setIsQnumModalVisible] = useState(false);


    const [fabrictypedata, setFabricTypeData] = useState<Fts[]>([]);
    const [selectedFts, setSelectedFts] = useState<number | null>(null);
    const [isFtModalVisible, setIsFtModalVisible] = useState(false);


    const [bcs, setBcs] = useState<Bc[]>([]);
    const [selectedBcs, setSelectedBcs] = useState<number | null>(null);
    const [isBcModalVisible, setIsBcModalVisible] = useState(false);


    const [scs, setScs] = useState<Sc[]>([]);
    const [selectedScs, setSelectedScs] = useState<number | null>(null);
    const [isScModalVisible, setIsScModalVisible] = useState(false);

    const [counts, setCounts] = useState<Count[]>([]);
    const [selectedCounts, setSelectedCounts] = useState<number | null>(null);
    const [isCountModalVisible, setIsCountModalVisible] = useState(false);


    const [compositions, setCompositions] = useState<Composition[]>([]);
    const [selectedComposition, setSelectedComposition] = useState<number | null>(null);
    const [isCompositionModalVisible, setIsCompositionModalVisible] = useState(false);


    const [finishes, setFinishes] = useState<Finish[]>([]);
    const [selectedFinish, setSelectedFinish] = useState<number | null>(null);
    const [isFinishModalVisible, setIsFinishModalVisible] = useState(false);


    const [widths, setWidths] = useState<Width[]>([]);
    const [selectedWidth, setSelectedWidth] = useState<number | null>(null);
    const [isWidthModalVisible, setIsWidthModalVisible] = useState(false);


    const [hcs, setHcs] = useState<Hc[]>([]);
    const [selectedHc, setSelectedHc] = useState<number | null>(null);
    const [isHcModalVisible, setIsHcModalVisible] = useState(false);


    const [pfs, setPfs] = useState<Pf[]>([]);
    const [selectedPf, setSelectedPf] = useState<number | null>(null);
    const [isPfModalVisible, setIsPfModalVisible] = useState(false);


    const [fabricpatterndata, setFabricPatternData] = useState<FPs[]>([]);
    const [selectedFp, setSelectedFp] = useState<number | null>(null);
    const [isFpModalVisible, setIsFpModalVisible] = useState(false);


    const [saleTypes, setSaleTypes] = useState<SaleType[]>([]);
    const [selectedSt, setSelectedSt] = useState<number | null>(null);
    const [isStModalVisible, setIsStModalVisible] = useState(false);


    const [pus, setPus] = useState<Pus[]>([]);
    const [selectedPus, setSelectedPus] = useState<number | null>(null);
    const [isPusModalVisible, setIsPusModalVisible] = useState(false);


    const [carings, setCarings] = useState<Carings[]>([]);
    const [selectedCaring, setSelectedCaring] = useState<number | null>(null);
    const [isCaringModalVisible, setIsCaringModalVisible] = useState(false);


    const [sizes, setSizes] = useState<Size[]>([]);
    const [selectedSize, setSelectedSize] = useState<number | null>(null);
    const [isSizeModalVisible, setIsSizeModalVisible] = useState(false);


    const [its, setIts] = useState<It[]>([]);
    const [selectedIt, setSelectedIt] = useState<number | null>(null);
    const [isItModalVisible, setIsItModalVisible] = useState(false);


    const [sns, setSns] = useState<Sn[]>([]);
    const [selectedSn, setSelectedSn] = useState<number | null>(null);
    const [isSnModalVisible, setIsSnModalVisible] = useState(false);

    // const [isVariantModalVisible, setIsVariantModalVisible] = useState(false);

    const [productVariants, setProductVariants] = useState<ProductVariants[]>([]);


    const [pagination, setPagination] = useState<{ current: number; pageSize: number; total: number }>({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const [filteredInfo, setFilteredInfo] = useState<Record<string, any>>({});
    const [sortedInfo, setSortedInfo] = useState<any>({});


    // const [imageFile, setImageFile] = useState<File | null>(null);
    // const [profileImageFileList, setProfileImageFileList] = useState<UploadFile[]>([]);


    const [isProductSubmitted, setIsProductSubmitted] = useState(false);

    const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
    const [selectedProductNameId, setSelectedProductNameId] = useState<number | null>(null);

    const [newlyCreatedProductId, setNewlyCreatedProductId] = useState<number | null>(null);


    const [fpparent, setFpParent] = useSearchParams();
    const [isFpChildModalVisible, setIsFpChildModalVisible] = useState(false);
    const [FpChildData, setFpChildData] = useState<FPs[]>([]);
    const [selectedFpParent, setSelectedFpParent] = useState<number | null>(0);

    const [selectedChildFpIds, setSelectedChildFpIds] = useState<number[]>([]);
    const [selectedChildFpData, setSelectedChildFpData] = useState<FPs[]>([]);


    const [isCreateProductVisible, setIsCreateProductVisible] = useState(false);
    const [isVariantModalVisible, setIsVariantModalVisible] = useState(false);

    const [isCopyVariant, setIsCopyVariant] = useState(false);


    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();



    const fetchProductByCode = async (code: string) => {
        try {
            const response = await apiRequest<Products>({ method: 'get', url: `/products/${code}` });
            setInitialValues(response);
            setIsEditMode(true);
        } catch (error) {
            showError('Failed to fetch product data');
            console.error(error);
        }
    };




    const fetchAllDataSequentially = async () => {
        try {
            const categoriesData = await apiRequest<Categories[]>({ method: 'get', url: `category?status=1` });
            setCategories(categoriesData);

            const brandNamesData = await apiRequest<BrandNames[]>({ method: 'get', url: `brand?status=1` });
            setBrandNames(brandNamesData);

            const productInfoData = await apiRequest<ProductInfo[]>({ method: 'get', url: `product-info?status=1` });
            setProductInfo(productInfoData);

            const pnsData = await apiRequest<Pn[]>({ method: 'get', url: `product-names?status=1` });
            setPns(pnsData);

            const qnsData = await apiRequest<Qn[]>({ method: 'get', url: `quality-names?status=1` });
            setQns(qnsData);

            const qnumsData = await apiRequest<Qnum[]>({ method: 'get', url: `quality-numbers?status=1` });
            setQnums(qnumsData);

            const ftData = await apiRequest<Fts[]>({ method: 'get', url: `fabric-types?status=1` });
            setFabricTypeData(ftData);

            const gstData = await apiRequest<GST[]>({ method: 'get', url: `gsts?status=1` });
            setGSTs(gstData);

            const countData = await apiRequest<Count[]>({ method: 'get', url: `counts?status=1` });
            setCounts(countData);

            const compositionData = await apiRequest<Composition[]>({ method: 'get', url: `compositions?status=1` });
            setCompositions(compositionData);

            const finishData = await apiRequest<Finish[]>({ method: 'get', url: `finishes?status=1` });
            setFinishes(finishData);

            const widthData = await apiRequest<Width[]>({ method: 'get', url: `widths?status=1` });
            setWidths(widthData);

            const hcData = await apiRequest<Hc[]>({ method: 'get', url: `hsn-codes?status=1` });
            setHcs(hcData);

            const pfData = await apiRequest<Pf[]>({ method: 'get', url: `price-formulas?status=1` });
            setPfs(pfData);

            const fpData = await apiRequest<FPs[]>({ method: 'get', url: `fabric-patterns?status=1&fp_parent=${selectedFpParent}` });
            setFabricPatternData(fpData);

            const saleTypesData = await apiRequest<SaleType[]>({ method: 'get', url: `sale-types?status=1` });
            setSaleTypes(saleTypesData);

            const pusData = await apiRequest<Pus[]>({ method: 'get', url: `product-uses?status=1` });
            setPus(pusData);

            const sizesData = await apiRequest<Size[]>({ method: 'get', url: `sizes?status=1` });
            setSizes(sizesData);

            const caringsData = await apiRequest<Carings[]>({ method: 'get', url: `carings?status=1` });
            setCarings(caringsData);

            const itsData = await apiRequest<It[]>({ method: 'get', url: `inspection-tailorings?status=1` });
            setIts(itsData);

            if (product_id) {
                await fetchProductByCode(product_id);
            }

        } catch (error) {
            showError('Failed to fetch some data');
            console.error(error);
        }
    };


    const debouncedFetchAllData = debounce(fetchAllDataSequentially, 500);

    useEffect(() => {
        debouncedFetchAllData();
    }, [product_id]);


    const getfpchilds = async (selectedFpParent: any) => {
        const fpData = await apiRequest<FPs[]>({ method: 'get', url: `fabric-patterns?status=1&fp_parent=${selectedFpParent}` });
        console.log("fpData");
        console.log(fpData);
        console.log("fpData");

        if (fpData) {
            setFpChildData(fpData);
            setIsFpChildModalVisible(true);
        } else {
            setIsFpChildModalVisible(false);
        }
    };

    useEffect(() => {
        if (selectedFpParent && selectedFpParent != 0) {
            getfpchilds(selectedFpParent);
        }
    }, [selectedFpParent]);




    const hideCreateModal = () => {
        setIsVariantModalVisible(false);
        setIsEditMode(false);
        setvariantInitialValues(null);
    };

    // Category
    const handleCategoryCreated = (newCategory: Categories) => {
        fetchAllDataSequentially();
        setSelectedCategories(newCategory.category_id);
        setIsCategoryModalVisible(false);
    };

    // definaltion of Categories
    interface Categories {
        category_id: number;
        category_name: string;
        category_status: number;
        category_short_code: string;
    }

    // Brand name
    const handleBrandNameCreated = (newBrandName: BrandNames) => {
        fetchAllDataSequentially();
        setSelectedBrandNames(newBrandName.brand_id);
        setIsBrandNameModalVisible(false);
    };

    // Product Info
    const handleProductInfoCreated = (newProductInfo: ProductInfo) => {
        fetchAllDataSequentially();
        setSelectedProductInfo(newProductInfo.pi_id);
        setIsProductInfoModalVisible(false);
    };

    // Product name
    const handlePnCreated = (newPn: Pn) => {
        fetchAllDataSequentially();
        setSelectedPns(newPn.pn_id);
        setIsPnModalVisible(false);
    };

    // Quality name
    const handleQnCreated = (newQn: Qn) => {
        fetchAllDataSequentially();
        setSelectedQns(newQn.qn_id);
        setIsQnModalVisible(false);
    };

    // Quality number
    const handleQnumCreated = (newQnum: Qnum) => {
        fetchAllDataSequentially();
        setSelectedQnums(newQnum.qn_id);
        setIsQnumModalVisible(false);
    };

    // Fabric type
    const handleFtCreated = (newFt: Fts) => {
        fetchAllDataSequentially();
        setSelectedFts(newFt.ft_id);
        setIsFtModalVisible(false);
    };

    // Counts
    const handleCountCreated = (newCount: Count) => {
        fetchAllDataSequentially();
        setSelectedCounts(newCount.count_id);
        setIsCountModalVisible(false);
    };

    // Composition
    const handleCompositionCreated = (newComposition: Composition) => {
        fetchAllDataSequentially();
        setSelectedComposition(newComposition.composition_id);
        setIsCompositionModalVisible(false);
    };

    // Finish
    const handleFinishCreated = (newFinish: Finish) => {
        fetchAllDataSequentially();
        setSelectedFinish(newFinish.finish_id);
        setIsFinishModalVisible(false);
    };

    // Width
    const handleWidthCreated = (newWidth: Width) => {
        fetchAllDataSequentially();
        setSelectedWidth(newWidth.width_id);
        setIsWidthModalVisible(false);
    };

    // HSN Code
    const handleHcCreated = (newHc: Hc) => {
        fetchAllDataSequentially();
        setSelectedHc(newHc.hc_id);
        setIsHcModalVisible(false);
    };

    // Price Formula
    const handlePfCreated = (newPf: Pf) => {
        fetchAllDataSequentially();
        setSelectedPf(newPf.pf_id);
        setIsPfModalVisible(false);
    };

    // Fabric Pattern
    const handleFpCreated = (newFp: FPs) => {
        fetchAllDataSequentially();
        setSelectedFp(newFp.fp_id);
        setIsFpModalVisible(false);
    };

    // Sale type
    const handleStCreated = (newSt: SaleType) => {
        fetchAllDataSequentially();
        setSelectedSt(newSt.st_id);
        setIsStModalVisible(false);
    };

    // Product Unit
    const handlePusCreated = (newPus: Pus) => {
        fetchAllDataSequentially();
        setSelectedPus(newPus.pu_id);
        setIsPusModalVisible(false);
    };

    // Caring
    const handleCaringCreated = (newCaring: Carings) => {
        fetchAllDataSequentially();
        setSelectedCaring(newCaring.caring_id);
        setIsCaringModalVisible(false);
    };

    // Sizes
    const handleSizeCreated = (newSize: Size) => {
        fetchAllDataSequentially();
        setSelectedSize(newSize.size_id);
        setIsSizeModalVisible(false);
    };

    // Inspection Tailoring
    const handleItCreated = (newIt: It) => {
        fetchAllDataSequentially();
        setSelectedIt(newIt.it_id);
        setIsItModalVisible(false);
    };

    // GST
    const handleGSTCreated = (newGST: GST) => {
        fetchAllDataSequentially();
        setSelectedGST(newGST.gst_id);
        setIsGSTModalVisible(false);
    };


    const handleCreate = () => {
        console.log("");
        fetchProductVariant()
    };


    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    // const handlePreview = async (file: UploadFile) => {
    //     if (!file.url && !file.preview) {
    //         file.preview = await getBase64(file.originFileObj as FileType);
    //     }
    //     setPreviewImage(file.url || (file.preview as string));
    //     setPreviewOpen(true);
    // };

    // const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    //     setFileList(newFileList);

    // const uploadButton = (
    //     <button style={{ border: 0, background: 'none' }} type="button">
    //         <PlusOutlined />
    //         <div style={{ marginTop: 8 }}>Upload</div>
    //     </button>
    // );


    const onFinish = (values: any) => {
        console.log('Form values:', values);
    };




    const handleAddProduct = async (values: any) => {
        try {
            const formData = new FormData();

            if (isEditMode && initialValues?.product_id) {
                formData.append('product_id', initialValues.product_id.toString());
            }

            formData.append('product_name', values.product_name);
            formData.append('product_code', values.product_code);
            formData.append('product_category', values.product_category);
            formData.append('product_brand_name', values.product_brand_name);
            formData.append('product_company_brand', values.product_company_brand);
            formData.append('product_gst', values.product_gst);
            formData.append('product_quality_name', values.product_quality_name);
            formData.append('product_info', values.product_info);
            formData.append('product_quality_number', values.product_quality_number);
            formData.append('product_fabric_type', values.product_fabric_type);
            formData.append('product_count', values.product_count);
            formData.append('product_composition', values.product_composition);
            formData.append('product_finish', values.product_finish);
            formData.append('product_width', values.product_width);
            formData.append('product_hsn_code', values.product_hsn_code);
            // formData.append('product_fabric_pattern', values.product_fabric_pattern);
            // formData.append(
            // 'product_fabric_pattern',
            // JSON.stringify(values.product_fabric_pattern || [])  // backend को array भेजोगे
            // );
            formData.append('product_fabric_pattern', values.product_fabric_pattern);
            formData.append('product_fabric_sub_pattern', values.product_fabric_sub_pattern);

            // formData.append('product_product_uses', values.product_product_uses);
            formData.append('product_product_uses', values.product_product_uses);
            formData.append('product_caring', values.product_caring);
            formData.append('product_inspection_trailoring', values.product_inspection_trailoring);
            formData.append('product_description', values.product_description);
            formData.append('product_keywords', values.product_keywords);
            formData.append('product_meta_title', values.product_meta_title);
            formData.append('product_meta_description', values.product_meta_description);

            // if (imageFile) {
            //     formData.append('attachments', imageFile); // ✅ binary image file
            // }

            const data = await apiRequest({
                method: initialValues?.product_id ? 'put' : 'post',
                url: initialValues?.product_id ? 'edit-product' : 'add-product',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            showSuccess(
                initialValues?.product_id
                    ? 'Product updated successfully!'
                    : 'Product created successfully!'
            );

            // form.resetFields();
            // setImageFile(null);
            // setProfileImageFileList([]);
            // 👇 Set new product ID (create ke case mein)
            const productId = initialValues?.product_id || data?.product_id;
            if (!productId) {
                throw new Error("Product ID missing from API response");
            }

            // setNewlyCreatedProductId(productId);
            setIsProductSubmitted(true);
            // setIsVariantModalVisible(true); // 👈 Variant Modal open karo
        } catch (error) {
            showError(`Failed to ${initialValues?.product_id ? 'update' : 'create'} product`);
        }
    };

    useEffect(() => {
        if (newlyCreatedProductId) {
            setIsVariantModalVisible(false);
        }
    }, [newlyCreatedProductId]);


    useEffect(() => {
        if (initialValues?.product_id) {

            setIsProductSubmitted(true);
            setNewlyCreatedProductId(initialValues?.product_id);
        } else {
            setIsProductSubmitted(false);

        }
    }, [initialValues?.product_id])

    useEffect(() => {
        if (initialValues) {
            const selectedPn = pns.find((pn) => pn.pn_name === initialValues.product_name);
            const selectedCategory = categories.find((category) => category.category_id === initialValues.product_category);
            const selectedBn = brandnames.find((bn) => bn.brand_id === initialValues.product_brand_name);
            const selectedQn = qns.find((q) => q.qn_id === initialValues.product_quality_name);
            const selectedQnum = qnums.find((qnum) => qnum.qn_id === initialValues.product_quality_number);
            const selectedFt = fabrictypedata.find((ft) => ft.ft_id === initialValues.product_fabric_type);
            const selectedCount = counts.find((c) => c.count_id === initialValues.product_count);
            const selectedComp = compositions.find((comp) => comp.composition_id === initialValues.product_composition);
            const selectedFinish = finishes.find((f) => f.finish_id === initialValues.product_finish);
            const selectedWidth = widths.find((w) => w.width_id === initialValues.product_width);
            const selectedHsn = hcs.find((h) => h.hc_id === initialValues.product_hsn_code);
            const selectedPattern = fabricpatterndata.find((fp) => fp.fp_id === initialValues.product_fabric_pattern);
            //    const selectedPatterns = fabricpatterndata.filter(
            //         (fp) => initialValues.product_fabric_sub_pattern.includes(String(fp.fp_parent))
            //     );
            // initialValues.product_fabric_sub_pattern में child IDs होते हैं
            const selectedChilds = fabricpatterndata.filter(fp =>
                initialValues.product_fabric_sub_pattern.includes(fp.fp_id.toString())
            );

            setSelectedChildFpData(selectedChilds);

            const selectedUses = pus
                .filter((p) => initialValues.product_product_uses.includes(p.pu_id.toString()))
                .map((p) => p.pu_id); // Extract array of pu_id
            const selectedCaring = carings
                .filter((c) => initialValues.product_caring.includes(c.caring_id.toString()))
                .map((c) => c.caring_id);
            const selectedIt = its
                .filter((i) => initialValues.product_inspection_trailoring.includes(i.it_id.toString()))
                .map((i) => i.it_id);
            const selectedgst = gsts.find((g) => g.gst_id === initialValues.product_gst);
            console.log('Form value before:', form.getFieldValue('product_category'));

            form.setFieldsValue({
                product_name: selectedPn?.pn_id,
                product_code: initialValues.product_code,
                product_category: initialValues.product_category,
                product_brand_name: selectedBn?.brand_id,
                product_company_brand: selectedBn?.brand_id,
                product_gst: selectedgst?.gst_id,
                product_quality_name: selectedQn?.qn_id,
                product_quality_number: selectedQnum?.qn_id,
                product_fabric_type: selectedFt?.ft_id,
                product_count: selectedCount?.count_id,
                product_composition: selectedComp?.composition_id,
                product_finish: selectedFinish?.finish_id,
                product_width: selectedWidth?.width_id,
                product_hsn_code: selectedHsn?.hc_id,
                product_fabric_pattern: selectedPattern?.fp_id,
                product_fabric_sub_pattern: selectedChilds,
                // product_product_uses: selectedUse?.pu_id,
                product_product_uses: selectedUses,
                product_caring: selectedCaring,
                product_inspection_trailoring: selectedIt,
                product_info: initialValues.product_info,
                product_description: initialValues.product_description,
                product_keywords: initialValues.product_keywords,
                product_meta_title: initialValues.product_meta_title,
                product_meta_description: initialValues.product_meta_description,

            });
            console.log('Form value after :', form.getFieldValue('product_category'));

            if (selectedCategory?.category_short_code) {
                setSelectedCategoryId(selectedCategory.category_short_code);
            }
            if (selectedPn?.pn_id) {
                setSelectedProductNameId(selectedPn?.pn_id);
            }


            // } else {
            //     form.resetFields();
            // }
            // ✅ Handle existing image preview
            // if (initialValues.product_image) {
            //     const imageUrl = `${initialValues.product_image}`; // If you have a base URL, include it here
            //     setProfileImageFileList([
            //         {
            //             uid: '-1',
            //             name: 'product.png',
            //             status: 'done',
            //             url: imageUrl,
            //         },
            //     ]);
            //     setImageFile(null); // Clear selected file so user can upload a new one if needed
            // }
        } else {
            form.resetFields();
            // setImageFile(null);
            // setProfileImageFileList([]);
        }
    }, [
        initialValues,
        pns,
        categories,
        brandnames,
        qns,
        qnums,
        fabrictypedata,
        counts,
        compositions,
        finishes,
        widths,
        hcs,
        fabricpatterndata,
        pus,
        carings,
        its,
        gsts,
        form,
    ]);

    const fetchProductVariant = async (page = 1, limit = 10) => {
        console.log("initialValues", initialValues)
        try {
            const url = `product-variants?page=${page}&limit=${limit}${isEditMode && initialValues?.product_id ? `&product_id=${initialValues.product_id}` : ''}`;
            const response = await apiRequest<{
                data: ProductVariants[];
                page: number;
                limit: number;
                total: number;
            }>({
                method: 'get',
                url,
            });
            setProductVariants(response.data);
            setPagination({
                current: response.page,
                pageSize: response.limit,
                total: response.total,
            });
        } catch {
            showError('Failed to fetch product variants');
        }
    };



    useEffect(() => {
        if (initialValues?.product_id) {

            fetchProductVariant(pagination.current, pagination.pageSize);
        }
    }, [initialValues?.product_id]);




    const handleTableChange: TableProps<ProductVariants>['onChange'] = (pagination, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleEditProductVariantClick = (record: ProductVariants) => {
        setIsVariantModalVisible(true)
        setvariantInitialValues(record);
        setIsEditMode(true);
    };

    // const handleCopyProductVariantClick = (record: ProductVariants) => {
    //     // Step 1: Open modal first
    //     setIsVariantModalVisible(true);

    //     // Step 2: Compute the next variant code (like FBoXI1-A1 or FBoXI1-A2)
    //     const relatedVariants = productVariants.filter(
    //         (v) => v.variant_parent_id === record.variant_id
    //     );

    //     let maxSuffix = 0;
    //     relatedVariants.forEach((v) => {
    //         const match = v.variant_code.match(/(\d+)$/);
    //         if (match) {
    //             const num = parseInt(match[1]);
    //             if (num > maxSuffix) maxSuffix = num;
    //         }
    //     });

    //     const newVariantCode = `${record.variant_code}${maxSuffix + 1}`;
    //     setvariantInitialValues(record);
    //     setIsCopyVariant(true);
    //     setIsEditMode(true);
    //     setIsVariantModalVisible(true);


    //     // Step 5: Force form value update
    //     const patchedValues = {
    //         ...variantinitialValues,
    //         variant_invoice_date: variantinitialValues?.variant_invoice_date
    //             ? dayjs(variantinitialValues.variant_invoice_date)
    //             : null,
    //     };

    //     // Tip: wait for modal to render before setting values
    //     setTimeout(() => {
    //         form.setFieldsValue(patchedValues);
    //     }, 0);
    // };


    const handleCopyProductVariantClick = (record: ProductVariants) => {
        setIsCopyVariant(true);
        setIsEditMode(true);

        // Step 1: नया variant code निकालो
        const relatedVariants = productVariants.filter(
            (v) => v.variant_parent_id === record.variant_id
        );

        let maxSuffix = 0;
        relatedVariants.forEach((v) => {
            const match = v.variant_code.match(/(\d+)$/);
            if (match) {
                const num = parseInt(match[1]);
                if (num > maxSuffix) maxSuffix = num;
            }
        });

        const newVariantCode = `${record.variant_code}${maxSuffix + 1}`;

        // Step 2: Initial values को set करो, पर variant_id null रखो
        const updatedRecord = {
            ...record,
            variant_code: newVariantCode, // code +1
        };

        setvariantInitialValues(updatedRecord);
        setIsVariantModalVisible(true);

        // Step 3: Modal render होने के बाद form को set करो
        setTimeout(() => {
            form.setFieldsValue({
                ...updatedRecord,
                variant_invoice_date: record.variant_invoice_date
                    ? dayjs(record.variant_invoice_date)
                    : null,
            });
        }, 0);
    };




    const cancel: PopconfirmProps['onCancel'] = (e) => {
        console.log(e);
        showError('Click on No');
    };
    const handleDelete = async (block_id: number) => {
        try {
            await apiRequest({
                method: 'delete',
                url: `/delete-block/${block_id}`,
            });
            showSuccess('product variant deleted');
            // fetchProductVariant();
        } catch {
            showError('Failed to delete product variant');
        }
    };

    const columns: TableColumnsType<ProductVariants> = [
        {
            title: 'Image',
            key: 'variant_image',
            render: (_: any, record: ProductVariants) => <VariantImageCell record={record} />,
        },
        {
            title: 'Variant Code',
            dataIndex: 'variant_code',
            key: 'variant_code',
            width: 30,
            render: (_, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span>{record.variant_code || 'N/A'}</span>
                    {record.variant_code && <CopyButton textToCopy={record.variant_code} />}
                </div>
            ),
        },
        {
            title: 'Variant Name',
            dataIndex: 'variant_name', // 👈 Must match the backend alias
            key: 'variant_name',
            width: 30,
            filters: Array.from(new Set(productVariants.map((p) => p.variant_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_name || null,
            // onFilter: (value, record) => record.variant_name.includes(value),
            sorter: (a, b) => a.variant_name.localeCompare(b.variant_name),
            sortOrder: sortedInfo.columnKey === 'variant_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Shade',
            dataIndex: 'sn_number',
            key: 'sn_number',
            width: 100,
            filters: Array.from(new Set(productVariants.map((p) => p.sn_number))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.sn_number || null,
            // onFilter: (value, record) => record.sn_number.includes(value as string),
            // sorter: (a, b) => a.sn_number.localeCompare(b.sn_number),
            sortOrder: sortedInfo.columnKey === 'sn_number' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Size',
            dataIndex: 'size_name',
            key: 'size_name',
            width: 80,
            filters: Array.from(new Set(productVariants.map((p) => p.size_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.size_name || null,
            sortOrder: sortedInfo.columnKey === 'size_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Base Color',
            dataIndex: 'bc_name',
            key: 'bc_name',
            width: 100,
            filters: Array.from(new Set(productVariants.map((p) => p.bc_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.bc_name || null,
            sortOrder: sortedInfo.columnKey === 'bc_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Sub Color',
            dataIndex: 'sc_name',
            key: 'sc_name',
            filters: Array.from(new Set(productVariants.map((p) => p.sc_name))).map((name) => ({
                text: name,
                value: name,
            })),
            width: 80,
            filterSearch: true,
            filteredValue: filteredInfo.sc_name || null,
            sortOrder: sortedInfo.columnKey === 'sc_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Grade',
            dataIndex: 'pg_name',
            key: 'pg_name',
            filters: Array.from(new Set(productVariants.map((p) => p.pg_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.pg_name || null,
            sortOrder: sortedInfo.columnKey === 'pg_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Mtr',
            dataIndex: 'variant_received_quantity_mtr',
            key: 'variant_received_quantity_mtr',
            filters: Array.from(new Set(productVariants.map((p) => p.variant_received_quantity_mtr))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_received_quantity_mtr || null,
            sortOrder: sortedInfo.columnKey === 'variant_received_quantity_mtr' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Qty',
            dataIndex: 'variant_received_quantity_pcs',
            key: 'variant_received_quantity_pcs',
            filters: Array.from(new Set(productVariants.map((p) => p.variant_received_quantity_pcs))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_received_quantity_pcs || null,
            sortOrder: sortedInfo.columnKey === 'variant_received_quantity_pcs' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Unit',
            dataIndex: 'ut_name',
            key: 'ut_name',
            filters: Array.from(new Set(productVariants.map((p) => p.ut_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.ut_name || null,
            sortOrder: sortedInfo.columnKey === 'ut_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Stock level',
            dataIndex: 'variant_stock_level',
            key: 'variant_stock_level',
            filters: Array.from(new Set(productVariants.map((p) => p.variant_stock_level))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_stock_level || null,
            sortOrder: sortedInfo.columnKey === 'variant_stock_level' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Created On',
            dataIndex: 'variant_created_on',
            key: 'variant_created_on',
            filters: Array.from(new Set(productVariants.map((p) => p.variant_created_on))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_created_on || null,
            sortOrder: sortedInfo.columnKey === 'variant_created_on' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
            render: (date: string) => date ? dayjs(date).format('DD-MM-YYYY') : ''
        },
        {
            title: 'Suppliar',
            dataIndex: 'ledger_first_name',
            key: 'ledger_first_name',
            filters: Array.from(new Set(productVariants.map((p) => p.ledger_first_name))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.ledger_first_name || null,
            sortOrder: sortedInfo.columnKey === 'ledger_first_name' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
        {
            title: 'Rate',
            dataIndex: 'variant_mrp',
            key: 'variant_mrp',
            filters: Array.from(new Set(productVariants.map((p) => p.variant_mrp))).map((name) => ({
                text: name,
                value: name,
            })),
            filterSearch: true,
            filteredValue: filteredInfo.variant_mrp || null,
            sortOrder: sortedInfo.columnKey === 'variant_mrp' ? sortedInfo.order : null,
            sortDirections: ['ascend', 'descend'],
            ellipsis: true,
        },
    ];

    columns.push({
        title: 'Action',
        width: 150,
        fixed: 'right',
        render: (_: any, record: ProductVariants) => (
            <Space size="middle">

                <>
                    {/* <Switch
                        checkedChildren="Active"
                        unCheckedChildren="Inactive"
                        checked={!!record.variant_status}
                        onChange={() => handleStatusToggle(record.variant_id)}
                    /> */}
                    <Button onClick={() => handleEditProductVariantClick(record)} className="px-8">
                        <EditOutlined />
                    </Button>
                    {!record.variant_parent_id && (
                        <Button onClick={() => handleCopyProductVariantClick(record)} className="px-8">
                            <CopyOutlined />
                        </Button>
                    )}

                </>

                {/* <Popconfirm
                    title="Delete this block number?"
                    onConfirm={() => handleDelete(record.variant_id)}
                    onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button danger className="px-8">
                        <DeleteOutlined />
                    </Button>
                </Popconfirm> */}
            </Space>
        ),
    });

    const adaptedFabricPatterns = fabricpatterndata.map((fp) => ({
        ...fp,
        fp_parent: fp.fp_parent ?? '',
        fp_image: fp.fp_image ?? '',
    }));



    const generateBarcode = (categoryId: string | null, productNameId: number | null): string => {
        if (!categoryId || !productNameId) return '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const timestamp = Date.now();
        let num = timestamp % 238328;
        let randomString = '';
        for (let i = 0; i < 3; i++) {
            randomString = characters.charAt(num % characters.length) + randomString;
            num = Math.floor(num / characters.length);
        }
        randomString = randomString.padStart(3, characters[0]);
        return `${categoryId}${randomString}${productNameId}`;
    };

    useEffect(() => {
        const barcode = generateBarcode(selectedCategoryId, selectedProductNameId);
        console.log("barcode==>", barcode);
        console.log("barcode==>", selectedCategoryId);
        form.setFieldsValue({ product_code: barcode });
    }, [selectedCategoryId, selectedProductNameId, form]);






    return (
        <>
            <Space
                style={{
                    display: 'flex',
                    marginBottom: 16,
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                <Breadcrumb style={{ display: 'inline-block', margin: 0 }}>
                    <Breadcrumb.Item href="/">
                        <HomeOutlined />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>View Products</Breadcrumb.Item>
                </Breadcrumb>
            </Space>

            <Form form={form} layout="vertical" onFinish={handleAddProduct}>
                <Row gutter={[16, 16]} style={{ margin: "15px" }}>
                    {/* LEFT SIDE: 3 rows with 2 columns each */}

                    {/* category */}
                    <Col xs={24} sm={12} md={8} >
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Category
                        </div>

                        <Form.Item name="product_category"
                            rules={[{ required: true, message: 'Please select a category!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <Select
                                    showSearch
                                    placeholder="Select Category"
                                    onChange={(value) => {
                                        const selected = categories.find((cat) => cat.category_id === value);
                                        console.log("from catogey sel", selected)
                                        form.setFieldsValue({
                                            product_category: selected ? selected.category_id : '',
                                            product_code: selected ? selected.category_short_code : '',
                                        });
                                        setSelectedCategoryId(selected ? selected.category_short_code : '');
                                    }}
                                    options={[
                                        { label: 'Select Category', value: undefined },
                                        ...categories.map((cat) => ({
                                            label: cat.category_name,
                                            value: cat.category_id,
                                        })),
                                    ]}
                                    allowClear
                                    filterOption={(input, option) =>
                                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    style={{ flex: 1, minWidth: 0 }}
                                    value={form.getFieldValue('product_category')}
                                />
                                <Button
                                    style={{ padding: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsCategoryModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* Reusable GST Modal */}
                        <CategoryModal
                            visible={isCategoryModalVisible}
                            onCancel={() => setIsCategoryModalVisible(false)}
                            onCreate={handleCategoryCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>

                    {/* Product Name */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Product Name
                        </div>
                        <Form.Item name="product_name"
                            rules={[{ required: true, message: 'Please select a product name!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Product Name"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = pns.find((pn) => pn.pn_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_name: selected.pn_name });
                                            } else {
                                                form.setFieldsValue({ product_name: '' });
                                            }
                                            setSelectedProductNameId(value)
                                        }}
                                        options={[
                                            { label: 'Select Product Name', value: null },
                                            ...pns.map((pn) => ({
                                                label: pn.pn_name,
                                                value: pn.pn_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_name')}
                                    />
                                </div>
                                <Button
                                    style={{ padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsPnModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <PnModal
                            visible={isPnModalVisible}
                            onCancel={() => setIsPnModalVisible(false)}
                            onCreate={handlePnCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Product code(barcode) */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Barcode
                        </div>
                        <Form.Item
                            name="product_code"
                            style={{ width: '100%' }}
                        >
                            <Input
                                width="100%"
                                maxLength={255}
                                placeholder="e.g., Barcode "
                                disabled

                            />
                        </Form.Item>
                    </Col>




                    {/* Company Brand */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Company Brand <span style={{ color: 'red' }}>*</span>
                        </div>
                        <Form.Item name="product_company_brand"
                            rules={[{ required: true, message: 'Please select a Company Brand!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Company Brand"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = brandnames.find((brand) => brand.brand_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_company_brand: selected.brand_id });
                                            } else {
                                                form.setFieldsValue({ product_company_brand: null });
                                            }
                                            setSelectedCompanyName(value)
                                        }}
                                        options={[
                                            { label: 'Select Company Brand', value: null },
                                            ...brandnames.map((brand) => ({
                                                label: brand.brand_name,
                                                value: brand.brand_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_company_brand')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsBrandNameModalVisible(true)} // modal for company brand
                                />
                            </AntInput.Group>
                        </Form.Item>
                    </Col>


                    {/* Brand */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Brand Name <span style={{ color: 'red' }}>*</span>
                        </div>

                        <Form.Item name="product_brand_name"
                            rules={[{ required: true, message: 'Please select a Brand Name!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Brand Name"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = brandnames.find((bn) => bn.brand_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_brand_name: selected.brand_id });
                                            } else {
                                                form.setFieldsValue({ product_brand_name: '' });
                                            } setSelectedBrandNames(value)
                                        }}
                                        options={[
                                            { label: 'Select Brand Name', value: null },
                                            ...brandnames.map((brand) => ({
                                                label: brand.brand_name,
                                                value: brand.brand_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_brand_name')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsBrandNameModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <BrandNameModel
                            visible={isBrandNameModalVisible}
                            onCancel={() => setIsBrandNameModalVisible(false)}
                            onCreate={handleBrandNameCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Product Info */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Product Info
                        </div>

                        <Form.Item name="product_info"
                            rules={[{ required: true, message: 'Please select a product user!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Product Info"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = productinfo.find((pi) => pi.pi_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_info: selected.pi_id });
                                            } else {
                                                form.setFieldsValue({ product_info: '' });
                                            } setSelectedProductInfo(value)
                                        }}
                                        options={[
                                            { label: 'Select Product Info', value: null },
                                            ...productinfo.map((pi) => ({
                                                label: pi.pi_name,
                                                value: pi.pi_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_info')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsProductInfoModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <PiModal
                            visible={isProductInfoModalVisible}
                            onCancel={() => setIsProductInfoModalVisible(false)}
                            onCreate={handleProductInfoCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>



                    {/* RIGHT SIDE: Image field taking full height */}
                    {/* <Col xs={24} md={8} style={{ padding: "10px" }}>
                        <div
                            style={{
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingTop: 8,
                            }}
                        >
                            <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>
                                Upload Product Image
                            </label>

                            <Form.Item required>
                                <div
                                    style={{
                                        width: '100%',
                                        maxHeight: profileImageFileList.length > 3 ? '225px' : 'auto',
                                        overflowY: profileImageFileList.length > 3 ? 'auto' : 'visible',
                                        transition: 'max-height 0.3s ease',
                                    }}
                                    className="centered-upload-wrapper"
                                >
                                    <Upload
                                        name="attachments"
                                        listType="picture-card"
                                        fileList={profileImageFileList}
                                        beforeUpload={() => false}
                                        onPreview={(file) => {
                                            setPreviewImage(file.url || (file.preview as string));
                                            setPreviewOpen(true);
                                        }}
                                        onChange={({ fileList }) => {
                                            setProfileImageFileList(fileList);

                                            const rawFile = fileList[0]?.originFileObj;
                                            if (rawFile instanceof File) {
                                                setImageFile(rawFile);
                                            } else {
                                                setImageFile(null);
                                            }
                                        }}
                                        onRemove={() => {
                                            setImageFile(null);
                                            setProfileImageFileList([]);
                                        }}
                                    >
                                        {profileImageFileList.length >= 1 ? null : (
                                            <div
                                                style={{
                                                    width: 220,
                                                    height: 220,
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <PlusOutlined style={{ fontSize: 24 }} />
                                                <div style={{ marginTop: 8 }}>Upload</div>
                                            </div>
                                        )}
                                    </Upload>
                                </div>

                                {previewImage && (
                                    <Image
                                        wrapperStyle={{ display: 'none' }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </Col> */}

                </Row>

                <Row gutter={[16, 16]} style={{ margin: "15px" }}>

                    {/* Quality Name  */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Quality Name
                        </div>

                        <Form.Item name="product_quality_name">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Quality Name"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = qns.find((qn) => qn.qn_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_quality_name: selected.qn_id });
                                            } else {
                                                form.setFieldsValue({ product_quality_name: null });
                                            }
                                            setSelectedQns(value)
                                        }}
                                        options={[
                                            { label: 'Select Quality Name', value: null },
                                            ...qns.map((qn) => ({
                                                label: qn.qn_name,
                                                value: qn.qn_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_quality_name')}
                                    />
                                </div>

                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsQnModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <QnModal
                            visible={isQnModalVisible}
                            onCancel={() => setIsQnModalVisible(false)}
                            onCreate={handleQnCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Quality Number  */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Quality Number
                        </div>

                        <Form.Item name="product_quality_number">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Quality Number"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = qnums.find((qnum) => qnum.qn_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_quality_number: selected.qn_id });
                                            } else {
                                                form.setFieldsValue({ product_quality_number: null });
                                            } setSelectedQnums(value)
                                        }}
                                        options={[
                                            { label: 'Select Quality Number', value: null },
                                            ...qnums.map((qnum) => ({
                                                label: qnum.qn_number,
                                                value: qnum.qn_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_quality_number')}
                                    />
                                </div>

                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsQnumModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <QnumModal
                            visible={isQnumModalVisible}
                            onCancel={() => setIsQnumModalVisible(false)}
                            onCreate={handleQnumCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Composition */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Composition
                        </div>

                        <Form.Item name="product_composition">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Composition"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = compositions.find(
                                                (composition) => composition.composition_id === value
                                            );
                                            if (selected) {
                                                form.setFieldsValue({ product_composition: selected.composition_id });
                                            } else {
                                                form.setFieldsValue({ product_composition: null });
                                            } setSelectedComposition(value)
                                        }}
                                        options={[
                                            { label: 'Select Composition', value: null },
                                            ...compositions.map((composition) => ({
                                                label: composition.composition_name,
                                                value: composition.composition_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_composition')}
                                    />
                                </div>

                                <Button
                                    style={{ padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsCompositionModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <CompositionModal
                            visible={isCompositionModalVisible}
                            onCancel={() => setIsCompositionModalVisible(false)}
                            onCreate={handleCompositionCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Counts */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Counts
                        </div>

                        <Form.Item name="product_count">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Count"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = counts.find((count) => count.count_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_count: selected.count_id });
                                            } else {
                                                form.setFieldsValue({ product_count: null });
                                            } setSelectedCounts(value)
                                        }}
                                        options={[
                                            { label: 'Select Count', value: null },
                                            ...counts.map((count) => ({
                                                label: count.count_name,
                                                value: count.count_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_count')}
                                    />
                                </div>

                                <Button
                                    style={{ padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsCountModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <CountModal
                            visible={isCountModalVisible}
                            onCancel={() => setIsCountModalVisible(false)}
                            onCreate={handleCountCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Width */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Width
                        </div>

                        <Form.Item name="product_width">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Width"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = widths.find((width) => width.width_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_width: selected.width_id });
                                            } else {
                                                form.setFieldsValue({ product_width: null });
                                            } setSelectedWidth(value)
                                        }}
                                        options={[
                                            { label: 'Select Width', value: null },
                                            ...widths.map((width) => ({
                                                label: width.width_name,
                                                value: width.width_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_width')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsWidthModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <WidthModal
                            visible={isWidthModalVisible}
                            onCancel={() => setIsWidthModalVisible(false)}
                            onCreate={handleWidthCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Finish */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Finish
                        </div>

                        <Form.Item name="product_finish">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Finish"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = finishes.find((finish) => finish.finish_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_finish: selected.finish_id });
                                            } else {
                                                form.setFieldsValue({ product_finish: null });
                                            } setSelectedFinish(value)
                                        }}
                                        options={[
                                            { label: 'Select Finish', value: null },
                                            ...finishes.map((finish) => ({
                                                label: finish.finish_name,
                                                value: finish.finish_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_finish')}
                                    />
                                </div>

                                <Button
                                    style={{ padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsFinishModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <FinishModal
                            visible={isFinishModalVisible}
                            onCancel={() => setIsFinishModalVisible(false)}
                            onCreate={handleFinishCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>

                    <Divider />


                    {/* Fabric type */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Fabric type
                        </div>

                        <Form.Item name="product_fabric_type">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select Fabric Type"
                                        style={{ width: '100%' }}
                                        onChange={(value) => {
                                            const selected = fabrictypedata.find((ft) => ft.ft_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_fabric_type: selected.ft_id });
                                            } else {
                                                form.setFieldsValue({ product_fabric_type: null });
                                            } setSelectedFts(value)
                                        }}
                                        options={[
                                            { label: 'Select Fabric Type', value: null },
                                            ...fabrictypedata.map((ft) => ({
                                                label: ft.ft_name,
                                                value: ft.ft_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_fabric_type')}
                                    />
                                </div>

                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsFtModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <FtModal
                            visible={isFtModalVisible}
                            onCancel={() => setIsFtModalVisible(false)}
                            onCreate={handleFtCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* Fabric Pattern */}
                    {/* <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Fabric Pattern
                        </div>

                        <Form.Item name="product_fabric_pattern" hidden>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select 
                                        showSearch
                                        className="left-rounded"
                                        placeholder="Select Fabric Pattern"
                                        style={{ width: '100%' }}
                                        onChange={(fpParent) => {
                                            console.log("fpParent", fpParent)
                                            if (fpParent) {
                                                setSelectedFpParent(fpParent); // update state here!

                                                setFpParent({ fp_parent: String(fpParent) });
                                            } else {
                                                setSelectedFpParent(0);
                                                setFpParent({});
                                            }
                                        }}
                                        options={[
                                            { label: 'Select Fabric Pattern', value: null },
                                            ...fabricpatterndata.map((fp) => ({
                                                label: fp.fp_pattern,
                                                value: fp.fp_id,
                                                key: fp.fp_id,
                                            })),
                                        ]}

                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_fabric_pattern')}
                                    />

                                </div>

                                <Button
                                    className="right-rounded"
                                    style={{ height: 46, width: 46, padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsFpModalVisible(true)}
                                />

                            </AntInput.Group>
                            {selectedChildFpData.length > 0 && (
                                <div style={{ marginTop: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ fontWeight: 500, marginBottom: 4 }}>Selected Patterns:</div>
                                        <Button size="small" type="link" onClick={() => setIsFpChildModalVisible(true)}>
                                            Change
                                        </Button>
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {selectedChildFpData.map((fp) => (
                                            <div
                                                key={fp.fp_id}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '4px 8px',
                                                    background: '#f5f5f5',
                                                    borderRadius: 4,
                                                    border: '1px solid #d9d9d9',
                                                }}
                                            >
                                                {fp.fp_pattern}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </Form.Item>




                        <FpModal
                            visible={isFpModalVisible}
                            onCancel={() => setIsFpModalVisible(false)}
                            onCreate={handleFpCreated}
                            isEditMode={false}
                            initialValues={null}
                            fabricpatterndata={fabricpatterndata}
                        />
                        <FpParentChildModal
                            visible={isFpChildModalVisible}
                            onCancel={() => setIsFpChildModalVisible(false)}
                            fp_parent={selectedFpParent ? String(selectedFpParent) : null}
                            initialSelectedIds={selectedChildFpIds}
                            onSubmit={({ selectedFpIds, image }) => {
                                console.log("Selected Child FP IDs:", selectedFpIds);
                                console.log("Uploaded Image:", image);

                                const selectedData = FpChildData.filter(fp => selectedFpIds.includes(fp.fp_id));

                                setSelectedChildFpIds(selectedFpIds);         // 🟢 Store IDs (optional)
                                setSelectedChildFpData(selectedData);         // 🟢 Store full data for UI rendering


                               
                                form.setFieldsValue({
                                    product_fabric_pattern: selectedFpIds, // 🔑 ek hidden field maintain kar lo
                                });
                            }}
                            fpData={FpChildData}

                        />



                    </Col> */}

                    {/* Fabric Pattern */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Fabric Pattern
                        </div>

                        {/* Parent Pattern Select */}
                        <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Select
                                    showSearch
                                    placeholder="Select Fabric Pattern"
                                    style={{ width: '100%' }}
                                    onChange={(fpParent) => {
                                        console.log("fpParent", fpParent);
                                        if (fpParent) {
                                            setSelectedFpParent(fpParent); // parent id set
                                            setFpParent({ fp_parent: String(fpParent) });
                                        } else {
                                            setSelectedFpParent(0);
                                            setFpParent({});
                                        }
                                    }}
                                    options={[
                                        { label: 'Select Fabric Pattern', value: null },
                                        ...fabricpatterndata.map((fp) => ({
                                            label: fp.fp_pattern,
                                            value: fp.fp_id,
                                            key: fp.fp_id,
                                        })),
                                    ]}
                                    allowClear
                                    filterOption={(input, option) =>
                                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                    }
                                    dropdownMatchSelectWidth={false}
                                    value={form.getFieldValue('product_fabric_pattern')}
                                />
                            </div>

                            <Button
                                style={{  padding: 0, flexShrink: 0 }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setIsFpModalVisible(true)}
                            />
                        </AntInput.Group>

                        <Form.Item name="product_fabric_pattern" hidden>
                            <Input type="hidden" />
                        </Form.Item>
                        {/* ✅ Hidden field jisme array of child IDs store hogi */}
                        <Form.Item name="product_fabric_sub_pattern" hidden>
                            <Input type="hidden" />
                        </Form.Item>

                        {/* Selected Child Patterns UI */}
                        {selectedChildFpData.length > 0 && (
                            <div style={{ marginTop: 8 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ fontWeight: 500, marginBottom: 4 }}>Selected Patterns:</div>
                                    <Button size="small" type="link" onClick={() => setIsFpChildModalVisible(true)}>
                                        Change
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                    {selectedChildFpData.map((fp) => (
                                        <div
                                            key={fp.fp_id}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                padding: '4px 8px',
                                                background: '#f5f5f5',
                                                borderRadius: 4,
                                                border: '1px solid #d9d9d9',
                                            }}
                                        >
                                            {fp.fp_pattern}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Parent Pattern Create Modal */}
                        <FpModal
                            visible={isFpModalVisible}
                            onCancel={() => setIsFpModalVisible(false)}
                            onCreate={handleFpCreated}
                            isEditMode={false}
                            initialValues={null}
                            fabricpatterndata={fabricpatterndata}
                        />

                        {/* Child Pattern Select Modal */}
                        <FpParentChildModal
                            visible={isFpChildModalVisible}
                            onCancel={() => setIsFpChildModalVisible(false)}
                            fp_parent={selectedFpParent ? String(selectedFpParent) : null}
                            initialSelectedIds={selectedChildFpIds}
                            // onSubmit={({ selectedFpIds }) => {
                            //   console.log("Selected Child FP IDs:", selectedFpIds);

                            //   const selectedData = FpChildData.filter(fp => selectedFpIds.includes(fp.fp_id));

                            //   setSelectedChildFpIds(selectedFpIds);   // State me ids
                            //   setSelectedChildFpData(selectedData);   // UI render ke liye

                            //   // ✅ Hidden field update karein
                            //   form.setFieldsValue({
                            //     product_fabric_pattern: selectedFpIds,
                            //   });

                            //   console.log("Form:", form.getFieldValue("product_fabric_pattern"));
                            // }}
                            onSubmit={({ selectedFpIds }) => {
                                // selectedFpIds = array of selected child fp IDs

                                // Child IDs को state में सेट करें (बाद UI में दिखाने के लिए)
                                setSelectedChildFpIds(selectedFpIds);

                                // Children का पूरा data filter करें
                                const selectedData = FpChildData.filter(fp => selectedFpIds.includes(fp.fp_id));
                                setSelectedChildFpData(selectedData);

                                // product_fabric_sub_pattern में child IDs स्टोर करें
                                form.setFieldsValue({
                                    product_fabric_sub_pattern: selectedFpIds,
                                });

                                // product_fabric_pattern में parent pattern (selectedFpParent) स्टोर करें
                                form.setFieldsValue({
                                    product_fabric_pattern: selectedFpParent,
                                });

                                // console log/debug
                                console.log("Parent pattern (fp_parent) stored:", selectedFpParent);
                                console.log("Child patterns stored:", selectedFpIds);
                            }}

                            fpData={FpChildData}
                        />
                    </Col>



                    {/* Product Uses */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Product Uses
                        </div>

                        <Form.Item name="product_product_uses">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        mode="multiple" // ✅ multi select
                                        placeholder="Select Product Uses"
                                        style={{
                                            width: '100%',
                                            border: '1px solid #d9d9d9', // ✅ default Ant Design border
                                            borderRadius: '4px',     
                                        }}
                                        onChange={(value) => {
                                            form.setFieldsValue({ product_product_uses: value }); // ✅ सीधे array set करो
                                            setSelectedPus(value); // अगर आपको state में भी रखना है
                                        }}
                                        options={[
                                            ...pus.map((pu) => ({
                                                label: (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <img
                                                            src={pu.pu_image || 'https://via.placeholder.com/32'}
                                                            alt={pu.pu_name}
                                                            style={{ width: 24, height: 24, objectFit: 'cover', borderRadius: 4 }}
                                                        />
                                                        <span>{pu.pu_name}</span>
                                                    </div>
                                                ),
                                                value: pu.pu_id,
                                            })),
                                        ]}
                                        allowClear

                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_product_uses')}
                                    />
                                </div>

                                <Button
                                    // className="right-rounded"
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsPusModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <PuModal
                            visible={isPusModalVisible}
                            onCancel={() => setIsPusModalVisible(false)}
                            onCreate={handlePusCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>



                    {/* Caring */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Caring
                        </div>

                        <Form.Item name="product_caring">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        mode="multiple" // ✅ multi select
                                        placeholder="Select Caring"
                                        style={{
                                            width: '100%',
                                            border: '1px solid #d9d9d9', // ✅ default Ant Design border
                                            borderRadius: '4px',   
                                        }}
                                        // onChange={(value) => {
                                        //     const selected = carings.find((caring) => caring.caring_id === value);
                                        //     if (selected) {
                                        //         form.setFieldsValue({ product_caring: selected.caring_id });
                                        //     } else {
                                        //         form.setFieldsValue({ product_caring: null });
                                        //     }setSelectedCaring(value)
                                        // }}
                                        onChange={(value) => {
                                            form.setFieldsValue({ product_caring: value }); // ✅ सीधे array set करो
                                            setSelectedCaring(value); // अगर आपको state में भी रखना है
                                        }}
                                        options={[
                                            { label: 'Select Caring', value: null },
                                            ...carings.map((caring) => ({
                                                label: caring.caring_instruction,
                                                value: caring.caring_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_caring')}
                                    />
                                </div>

                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsCaringModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <CaringModel
                            visible={isCaringModalVisible}
                            onCancel={() => setIsCaringModalVisible(false)}
                            onCreate={handleCaringCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>



                    {/* Inspection Tailoring */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Inspection Tailoring
                        </div>

                        <Form.Item name="product_inspection_trailoring">
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        mode="multiple" // ✅ multi select
                                        placeholder="Select Inspection Tailoring"
                                        style={{
                                            width: '100%',
                                            border: '1px solid #d9d9d9', // ✅ default Ant Design border
                                            borderRadius: '4px',     
                                        }}
                                        onChange={(value) => {
                                            form.setFieldsValue({ product_inspection_trailoring: value });
                                            setSelectedIt(value);
                                        }}
                                        options={[
                                            { label: 'Select Inspection Tailoring', value: null },
                                            ...its.map((it) => ({
                                                label: it.it_name,
                                                value: it.it_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_inspection_trailoring')}
                                    />
                                </div>

                                <Button
                                    style={{ padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsItModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        <ItModal
                            visible={isItModalVisible}
                            onCancel={() => setIsItModalVisible(false)}
                            onCreate={handleItCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>


                    {/* HSN Code */}
                    <Col xs={24} sm={24} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            HSN/SAC <span style={{ color: 'red' }}>*</span>
                        </div>

                        <Form.Item name="product_hsn_code"
                            rules={[{ required: true, message: 'Please select a HSN/SAC!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select HSN/SAC"
                                        style={{
                                            width: '100%',
                                            border: '1px solid #d9d9d9', // ✅ default Ant Design border
                                            borderRadius: '4px',          // ✅ border radius
                                            padding: '5px 8px',           // optional spacing
                                        }}
                                        onChange={(value) => {
                                            const selected = hcs.find((hc) => hc.hc_id === value);
                                            // form.setFieldsValue({
                                            //     product_hsn_code: selected ? selected.hc_id : null,
                                            // });
                                            if (selected) {
                                                form.setFieldsValue({ product_hsn_code: selected.hc_id });
                                            } else {
                                                form.setFieldsValue({ product_hsn_code: null });
                                            } setSelectedHc(value)
                                        }}
                                        options={[
                                            { label: 'Select HSN/SAC ', value: null },
                                            ...hcs.map((hc) => ({
                                                label: hc.hc_name,
                                                value: hc.hc_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_hsn_code')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsHcModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* HSN Modal */}
                        <HcModal
                            visible={isHcModalVisible}
                            onCancel={() => setIsHcModalVisible(false)}
                            onCreate={handleHcCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>





                    {/* GST */}
                    <Col xs={24} sm={24} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            GST(%) <span style={{ color: 'red' }}>*</span>
                        </div>

                        <Form.Item name="product_gst"
                            rules={[{ required: true, message: 'Please select a GST!' }]}>
                            <AntInput.Group compact style={{ display: 'flex', flexWrap: 'nowrap', width: '100%' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <Select
                                        showSearch
                                        placeholder="Select GST"
                                        style={{
                                            width: '100%',
                                            border: '1px solid #d9d9d9', // ✅ default Ant Design border
                                            borderRadius: '4px',          // ✅ border radius
                                            padding: '5px 8px',           // optional spacing
                                        }}
                                        onChange={(value) => {
                                            const selected = gsts.find((gst) => gst.gst_id === value);
                                            if (selected) {
                                                form.setFieldsValue({ product_gst: selected.gst_id });
                                            } else {
                                                form.setFieldsValue({ product_gst: null });
                                            } setSelectedGST(value)
                                        }}
                                        options={[
                                            { label: 'Select GST', value: null },
                                            ...gsts.map((gst) => ({
                                                label: gst.gst_name,
                                                value: gst.gst_id,
                                            })),
                                        ]}
                                        allowClear
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                        dropdownMatchSelectWidth={false}
                                        value={form.getFieldValue('product_gst')}
                                    />
                                </div>
                                <Button
                                    style={{  padding: 0, flexShrink: 0 }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={() => setIsGSTModalVisible(true)}
                                />
                            </AntInput.Group>
                        </Form.Item>

                        {/* GST Modal */}
                        <GSTModal
                            visible={isGSTModalVisible}
                            onCancel={() => setIsGSTModalVisible(false)}
                            onCreate={handleGSTCreated}
                            isEditMode={false}
                            initialValues={null}
                        />
                    </Col>
                </Row>


                <Divider />


                <Row gutter={[16, 16]} style={{ margin: "15px" }}>
                    {/* Keywords */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Keywords
                        </div>
                        <Form.Item
                            name="product_keywords"
                            style={{ width: '100%', padding: 0, margin: 0 }}
                            rules={[
                                { required: false, message: 'Please enter keywords' },
                            ]}
                        >
                            <Input
                                width="100%"
                                maxLength={255}
                                placeholder="e.g., keywords "

                            />
                        </Form.Item>
                    </Col>
                    {/* Meta Title */}
                    <Col xs={24} sm={12} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Meta Title
                        </div>
                        <Form.Item name="product_meta_title" style={{ width: '100%', padding: 0, margin: 0 }}>
                            <Input
                                maxLength={255}
                                placeholder="e.g., Meta Title " />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Meta Description
                        </div>
                        <Form.Item name="product_meta_description">
                            <Input
                                maxLength={255}
                                placeholder="e.g., Meta Description " />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={24} >
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>
                            Description
                        </div>
                        <Form.Item
                            name="product_description"
                            style={{ width: '100%', padding: 0, margin: 0 }}
                            rules={[
                                { required: false, message: 'Please enter Remark' },
                            ]}
                        >
                            <TextArea rows={5} placeholder="Remark" maxLength={1000} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} >
                        <Form.Item
                            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Button type="primary" htmlType="submit">
                                Submit Product
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>


                <Divider />


                <Row gutter={[16, 16]} style={{ margin: "15px" }}>
                    <Col xs={24} sm={12} md={8} >
                        {isProductSubmitted && (
                            <Form.Item>
                                <Button type="primary" onClick={() => setIsVariantModalVisible(true)}>
                                    Add Variant
                                </Button>
                            </Form.Item>
                        )}
                    </Col>
                </Row>




                {/* <VariantsModel
                    visible={isVariantModalVisible}
                    onCancel={hideCreateModal}
                    onCreate={handleCreate}
                    isEditMode={isEditMode}
                    variantinitialValues={variantinitialValues}
                    product_id={initialValues?.product_id}
                    productVariants={productVariants}
                    initialValues={initialValues}
                /> */}
                <VariantsModel
                    visible={isVariantModalVisible}
                    onCancel={() => setIsVariantModalVisible(false)}
                    onCreate={handleCreate}
                    isEditMode={isEditMode} // or based on condition
                    isCopyVariant={isCopyVariant} // or based on condition
                    variantinitialValues={variantinitialValues}
                    product_id={newlyCreatedProductId} // ✅ Yahi hai variant_product_id
                    productVariants={productVariants}
                    initialValues={initialValues}
                />



            </Form>
            <div
                style={{
                    minHeight: 360,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >
                <Table<ProductVariants>
                    tableLayout="auto"
                    className={`${styles.customTable} scrollable-table`}
                    columns={columns}
                    onChange={handleTableChange}
                    rowKey="voucher_id"
                    dataSource={productVariants.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    bordered
                    pagination={false}
                    // scroll={{ y: 37 * 15 }}
                    scroll={{ x: 1900, y: 37 * 15 }}
                    locale={{ emptyText: 'No product found' }}
                />


            </div>

        </>

    );
};

export default CreateProduct;
